export default {
  baseStyle: {
    color: 'primary.600',
  },
  sizes: {
    sm: 'small',
    lg: 'large',
  },
  defaultProps: {
    size: 'small',
  },
};
